'use client'

import { Button } from '@/components/ui/button'
import Link from 'next/link'
import type { Tab } from '../../_hooks/tab-navigation/useMyPageTabs'
import type React from 'react'

type TabNavigationProps = {
  tabs: Tab[]
  activeTab: string
  subTabs: Tab[]
  activeSubTab: string | null
}

export const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  subTabs,
  activeSubTab,
}) => (
  <>
    <div className="w-full overflow-x-auto">
      <nav className="flex min-w-max sm:min-w-0 sm:w-full sm:max-w-[1000px] sm:mx-auto ml-4 mr-4 gap-2 sm:gap-4 sm:px-6">
        {tabs.map((tab) => (
          <Link
            key={tab.path}
            href={tab.path}
            className="flex-1 min-w-[140px] sm:min-w-0"
            passHref
          >
            <Button
              variant="ghost"
              className={`w-full h-full px-2 py-2.5 sm:py-2.5 rounded-none border border-black text-sm font-normal whitespace-nowrap ${
                activeTab === tab.path
                  ? 'bg-black text-white hover:bg-black hover:text-white'
                  : 'bg-white text-black hover:bg-gray-50'
              }`}
              role="tab"
              aria-selected={activeTab === tab.path}
              aria-controls={`${tab.path.slice(1)}-panel`}
            >
              {tab.name}
            </Button>
          </Link>
        ))}
      </nav>
    </div>

    {subTabs.length > 0 && (
      <div className="w-full overflow-x-auto mt-6 sm:mt-8">
        <nav className="flex justify-center gap-3 px-4 mx-auto">
          <div className="inline-flex gap-1 sm:gap-2">
            {subTabs.map((subTab) => (
              <Link
                key={subTab.path}
                href={subTab.path}
                className="shrink-0"
                passHref
              >
                <Button
                  variant="ghost"
                  className={`w-full h-[30px] sm:h-[39px] px-2 sm:px-4 rounded-none border border-black text-sm font-normal ${
                    activeSubTab === subTab.path
                      ? 'bg-black text-white hover:bg-black hover:text-white'
                      : 'bg-white text-black hover:bg-gray-50'
                  }`}
                  role="tab"
                  aria-selected={activeSubTab === subTab.path}
                  aria-controls={`${subTab.path.slice(1)}-panel`}
                >
                  {subTab.name}
                </Button>
              </Link>
            ))}
          </div>
        </nav>
      </div>
    )}
  </>
)
